import { render, staticRenderFns } from "./CategoryFilters.vue?vue&type=template&id=45ea83e9&scoped=true"
import script from "./CategoryFilters.vue?vue&type=script&lang=ts"
export * from "./CategoryFilters.vue?vue&type=script&lang=ts"
import style0 from "./CategoryFilters.vue?vue&type=style&index=0&id=45ea83e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ea83e9",
  null
  
)

export default component.exports